import { render, staticRenderFns } from "./Underload_report.vue?vue&type=template&id=6dbd949f&"
import script from "./Underload_report.vue?vue&type=script&lang=js&"
export * from "./Underload_report.vue?vue&type=script&lang=js&"
import style0 from "./Underload_report.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports